import { Box, styled } from '@mui/material';

export const MainWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '100%',
  maxWidth: '100%',
  minWidth: '860px',
  flexShrink: 0,
  flexGrow: 1,
}) as typeof Box;

export const SectionWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '100%',
  maxWidth: '100%',
  flexShrink: 0,
}) as typeof Box;
